import { ArtistI } from '@tacans/shared-marketplace-layer';
import Link from 'next/link';
import React from 'react';
import { generatePath, RouteE } from 'src/constants/pages.constants';
import { Typography } from 'src/ui/common/atoms/typography';
import { decodeHTMLEntities, wipeHtml } from 'src/utils/html.utils';
import { StyledContainer, StyledInfo, StyledLazyLoadImage, StyledLink } from './styles';

export const CreatorCard = ({ data: { displayName, avatarAssets, country, id } }: { data: ArtistI }) => (
    <Link href={generatePath(RouteE.CREATOR_PROFILE, { id })} passHref>
        <StyledLink rel="canonical">
            <StyledContainer alignItems="center" flexDirection="column">
                <StyledLazyLoadImage
                    width="100%"
                    src={avatarAssets?.webps?.mediumUrl ?? avatarAssets?.originalUrl}
                    retinaSrc={avatarAssets?.webps?.largeUrl ?? avatarAssets?.originalUrl}
                />
                <StyledInfo flexDirection="column" alignItems="center" justifyContent="center">
                    <Typography size="sm" color="white" variant="title" overflowLines={1}>
                        {decodeHTMLEntities(wipeHtml(displayName))}
                    </Typography>
                    <Typography size="xs">{country}</Typography>
                </StyledInfo>
            </StyledContainer>
        </StyledLink>
    </Link>
);